import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, Button } from '@material-ui/core';
import instance from '../../../request/http';
import { BASE_URL } from '../../../store/config';
import { deduplicationObjArr2 } from '../../../common/utils';

const Root = styled(Box)({
    width: '801px',
    padding: '24px',
    '& .pageTitle': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#005E96',
    },
    '& .textField': {
        width: '159px',
        margin: '0 0 0 10px',
    },
    '& .table': {
        width: '100%',
        borderCollapse: 'collapse',
        border: '1px solid #EDEDED',
        '& th': {
            height: '35px',
            backgroundColor: '#EDEDED',
            border: '1px solid #EDEDED'
        },
        '& td': {
            height: '35px',
            border: '1px solid #EDEDED'
        },
        '& .noBorder': {
            border: 'none',
        },
        '& .addBtn': {
            verticalAlign: 'top',
        },
        '& .bgTransparent': {
            backgroundColor: 'transparent',
        },
        // '& Button': {
        //     backgroundColor: '#fff',
        // },
    },

    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#A1A1A1',
        opacity: '0.12',
        margin: '20px 0',
    },
    '& .title': {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#0060A0',
        margin: '34px 0 26px 0',
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginRight: '20px',
        },
    },
})
class AttorneyRate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            typeArr: [
                "legal fee",
                "filing fee",
                "Registered Agent Annual Fee",
                "Printing & Mailing Fee",
                "Third Party Fee"
            ],
            temp_item: "",
            name: "",
            rateData: [],
            serviceData: [],
        }
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleRateChange = this.handleRateChange.bind(this);
        this.handleServiceChange = this.handleServiceChange.bind(this);
        this.handleCheckBox = this.handleCheckBox.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
    }
    render() {
        const {
            rateData,
        } = this.state;
        return (
            <Root>
                {/* <div className="title">Please Select the Following Available Timesheet add to the Legal List</div> */}
                {/* <table className="table" cellPadding={10}>
                    <thead>
                        <tr>
                            <th align="center" width="22%" className="noBorder">Data</th>
                            <th align="center" width="20%" className="noBorder">Legal Item</th>
                            <th align="center" width="23%" className="noBorder">Description(Note)</th>
                            <th align="center" width="20%" className="noBorder">Attorney</th>
                            <th align="center" width="10%" className="noBorder">Rate</th>
                            <th align="center" width="5%" className="noBorder">Billable Hour</th>
                        </tr>
                    </thead>
                    <tbody>
                        {serviceData.map((row, index) => (
                            <tr key={index}>
                                <td align="center">
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={row.check}
                                                onChange={e => this.handleCheckBox(e, index)}
                                                color="primary"
                                            />
                                        }
                                        label={timeFormat(row.date)}
                                    />
                                </td>
                                <td align="center">
                                    <div>{this.changeType(row.type)}</div>
                                </td>
                                <td>{row.description}</td>
                                <td align="center">{this.handlerName(row.handler)}</td>
                                <td align="center">${toMoney(row.handler ? row.handler.rate : 0)}</td>
                                <td align="center">{this.changeSToH(row.hours)}</td>
                                <td align="center">{row.hours}</td>
                            </tr>
                        ))}
                    </tbody>
                </table> */}
                <div className="title">Related Attorney’s Rate</div>
                <table className="table" cellPadding={10}>
                    <thead>
                        <tr>
                            <th width="50%" align="center" className="noBorder">Name</th>
                            <th width="50%" align="center" className="noBorder">Rate</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rateData.map((row, index) => (
                            <tr key={index}>
                                <td align="center">{row.handler.first_name + " " + row.handler.last_name}</td>
                                <td align="center">
                                    <div className="h h-c">
                                        <span>$</span>
                                        <TextField
                                            id="outlined-name"
                                            className="textField"
                                            value={row.rate}
                                            onChange={e => this.handleRateChange(e, index)}
                                            margin="dense"
                                            variant="outlined"
                                            inputProps={{
                                                style: {
                                                    height: '5px',
                                                    padding: '14px',
                                                },
                                            }}
                                        />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div className="line"></div>
                <div className="foot h h-r">
                    <Button className="btn" variant="contained" onClick={this.handleCancel}>CANCEL</Button>
                    <Button variant="contained" color="primary" onClick={this.handleCreate}>CONFIRM TO IMPORT</Button>
                </div>
            </Root>
        )
    }
    componentDidMount() {
        // this.getTimesheets();
        // const data = this.props.data;
        // console.log(data)
        // const newData = deduplicationObjArr2(data, "handler", "id");
        // this.setState(() => ({
        //     rateData: newData
        // }))

        const data = this.props.data;
        let rateData = [];
        console.log(data)
        for (const obj of data) {
            if (obj.is_manual_rate === false) {
                rateData.push(obj);
            }
        }
        const newData = deduplicationObjArr2(rateData, "handler", "id");
        this.setState(() => ({
            rateData: newData
        }))
    }
    getTimesheets() {
        const { matterId } = this.props;
        this.getTimesheet(matterId);
    }
    handleCreate() {
        const { rateData } = this.state;
        this.props.handleCreate(rateData);
    }
    handleSelect(e, index) {
        const value = e.target.value;
        let [...serviceData] = this.state.serviceData;
        const obj = serviceData[index];
        obj.serviceItem = value;
        console.log(obj)
        this.setState(() => ({
            serviceData,
        }))
    }
    handleEdit(e, name) {
    }
    handleCancel() {
        this.props.handleCancel();
    }
    handleRateChange(e, index) {
        const { rateData } = this.state;
        const value = e.target.value;
        let obj = rateData[index];
        obj.rate = value;
        this.setState({
            rateData
        }, () => {
            // this.setRateToService();
        })
    }
    handleServiceChange(e, index) {
        const { serviceData } = this.state;
        const value = e.target.value;
        let obj = serviceData[index];
        obj.serviceItem = value;
        this.setState(() => ({
            serviceData
        }))
    }
    handleCheckBox(e, index) {
        const { serviceData } = this.state;
        let obj = serviceData[index];
        obj.check = !obj.check;
        this.setState({
            serviceData
        }, () => {
            this.setAttorneys();
        })
    }
    changeType(str) {
        if (str === "legal_fee") return "legal fee";
        return str;
    }
    changeHToS(h) {
        return parseFloat(h * 3600);
    }
    changeSToH(s, plusNum = 0) {
        let totalS = parseFloat(s) + parseFloat(plusNum);
        if (totalS) {
            return Math.floor(((totalS + 35) / 3600) * 100) / 100;
        } else {
            return 0;
        }
    }
    setAttorneys() {
        const { serviceData } = this.state;
        let tempRateData = [];
        for (const obj of serviceData) {
            if (obj.check) {
                tempRateData.push(obj)
            }
        }
        console.log(tempRateData)
        // const rateData = deduplicationObjArr2(tempRateData, "handler", "id");
        this.setState(() => ({
            tempRateData
        }));
    }
    setRateToService() {
        const { serviceData, rateData } = this.state;
        let [...tempServiceData] = serviceData;
        let [...tempRateData] = rateData;

        for (const rateObj of tempRateData) {
            for (const servObj of tempServiceData) {
                if (servObj.handler.id === rateObj.handler.id) {
                    servObj.handler.rate = rateObj.handler.rate;
                }
            }
        }
        this.setState(() => ({
            serviceData: tempServiceData
        }));
    }
    getArrIndex(objArr, key, key2, name) {
        return objArr.findIndex((element) => (element[key][key2] === name));
    }
    handlerName(obj) {
        if (!obj) return "";
        const firstName = obj.first_name ? obj.first_name : "";
        const lastName = obj.last_name ? obj.last_name : "";
        return firstName + " " + lastName;
    }
    //----------------request-------------------------------
    getTimesheet(matter_id) {
        const params = {
            matter_id
        }
        instance.get(BASE_URL + 'billing/legal_fee', { params }).then((res) => {
            const timesheetData = res.data.data;
            console.log(timesheetData);
            let serviceData = [];
            for (const obj of timesheetData) {
                obj.check = false;
                serviceData.push(obj);
            }
            this.setState(() => ({
                serviceData
            }))
        })
    }
}

export default AttorneyRate;